import { Component, OnInit } from '@angular/core';
import { CheckoutService } from '../../providers/checkout.service';
import { Submitted_entries_cheque_receipt } from '../../models/submitted_entries_cheque_receipt';
import { Horse_show } from '../../models/horse_show';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-entries-cheque-receipt',
  templateUrl: './entries-cheque-receipt.component.html',
styleUrls:  ['./entries-cheque-receipt.component.css']
})
export class EntriesChequeReceiptComponent  extends SmsAbstractAppPage implements OnInit {

  receipt: Submitted_entries_cheque_receipt = new Submitted_entries_cheque_receipt({});
  horse_show: Horse_show = new Horse_show({});

  constructor(private checkoutService: CheckoutService) {
    super();
  }

  ngOnInit() {
    this.checkoutService.getSubmitted_entries_cheque_receipt().subscribe(receipt => {
      this.receipt = receipt;

    }, error => {
      this.handleError(error);
    });
  }

}
